import { render, staticRenderFns } from "./WorkItem.vue?vue&type=template&id=e571fede&scoped=true&"
import script from "./WorkItem.vue?vue&type=script&lang=js&"
export * from "./WorkItem.vue?vue&type=script&lang=js&"
import style0 from "./WorkItem.vue?vue&type=style&index=0&id=e571fede&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e571fede",
  null
  
)

export default component.exports